const DEFAULT_FEATURE_UNAVAILABLE_MESSAGE =
  'This feature is currently unavailable for your tenant. Please contact your super admin.';

const FEATURE_BY_ENDPOINT = [
  { match: '/payroll', feature: 'PayrollBilling' },
  { match: '/report/weekly-all', feature: 'Performance Reports' },
  { match: '/report/daterange-all', feature: 'Performance Reports' },
  { match: '/report/weekly', feature: 'Performance Reports' },
  { match: '/report/daterange', feature: 'Performance Reports' },
  { match: '/report', feature: 'Performance Reports' },
  { match: '/weekly-attendance', feature: 'WeeklyAttendanceReports' },
  { match: '/leave', feature: 'Leave Management' },
  { match: '/employee', feature: 'Employee Management' },
  { match: '/attendance', feature: 'Attendance' },
  { match: '/location', feature: 'Location Tracking' },
  { match: '/shift', feature: 'Shift Management' },
  { match: '/project', feature: 'Project Management' },
  { match: '/job', feature: 'Job Management' },
];

export const getApiResponseMessage = (responseData) => {
  if (typeof responseData === 'string') return responseData.trim();
  return typeof responseData?.message === 'string' ? responseData.message.trim() : '';
};

export const isForbiddenError = (error) => {
  if (!error) return false;
  return error.response?.status === 403 || error.status === 403;
};

export const isFeatureUnavailableError = (error) => {
  if (!isForbiddenError(error)) return false;

  const message = (
    getApiResponseMessage(error?.response?.data) ||
    error?.message ||
    ''
  )
    .toString()
    .toLowerCase();

  if (!message) return true;

  return (
    message.includes('forbidden') ||
    message.includes('permission') ||
    message.includes('access') ||
    message.includes('feature') ||
    message.includes('disabled')
  );
};

export const buildFeatureUnavailableError = (featureName = 'This feature') => ({
  type: 'feature_unavailable',
  title: `${featureName} Unavailable`,
  message: DEFAULT_FEATURE_UNAVAILABLE_MESSAGE,
});

export const buildGenericApiError = (fallbackMessage) => ({
  type: 'error',
  title: 'Unable to Load Data',
  message: fallbackMessage || 'Something went wrong. Please try again.',
});

export const getRequestEndpoint = (error) => {
  const raw = error?.config?.url || error?.response?.config?.url || '';
  if (!raw) return '';

  const withoutDomain = raw.replace(/^https?:\/\/[^/]+/i, '');
  const [pathOnly] = withoutDomain.split('?');
  return pathOnly || withoutDomain;
};

export const inferFeatureNameFromEndpoint = (endpoint) => {
  if (!endpoint) return 'This feature';
  const normalizedEndpoint = endpoint.toLowerCase();
  const matched = FEATURE_BY_ENDPOINT.find((item) => normalizedEndpoint.includes(item.match));
  return matched?.feature || 'This feature';
};

export const buildForbiddenFeedback = (error) => {
  const endpoint = getRequestEndpoint(error);
  const featureName = inferFeatureNameFromEndpoint(endpoint);
  const backendMessage = getApiResponseMessage(error?.response?.data);

  return {
    endpoint,
    featureName,
    title: `${featureName} Unavailable`,
    message: backendMessage || (endpoint
      ? `${featureName} is not available for this tenant right now (blocked endpoint: ${endpoint}).`
      : `${featureName} is not available for this tenant right now.`),
  };
};
